import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'integerToFloat',
  standalone: true
})
export class IntegerToFloatPipe implements PipeTransform {
  transform(value: bigint | number | null | undefined, scale: number = 4, precision: number = 2): string {
    if (value === null || value === undefined) return '';
    let bigintVal: bigint;
    try {
      bigintVal = BigInt(value);
    } catch {
      return '0.00';
    }
    const negative = bigintVal < 0n;
    const absVal = negative ? -bigintVal : bigintVal;
    const divisor = 10n ** BigInt(scale);
    const whole = absVal / divisor;
    let fraction = absVal % divisor;
    
    const diff = scale - precision;
    if (diff > 0) {
      const roundingDivisor = 10n ** BigInt(diff);
      const half = roundingDivisor / 2n;
      const remainder = fraction % roundingDivisor;
      fraction = fraction / roundingDivisor;
      if (remainder >= half) fraction += 1n;
    } else if (diff < 0) {
      fraction = fraction * (10n ** BigInt(-diff));
    }
    
    const precisionLimit = 10n ** BigInt(precision);
    let finalWhole = whole;
    if (fraction >= precisionLimit) {
      fraction -= precisionLimit;
      finalWhole += 1n;
    }
    return `${negative ? '-' : ''}${finalWhole.toString()}.${fraction.toString().padStart(precision, '0')}`;
  }
}
